import "regenerator-runtime/runtime";
import "core-js";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";

//import $ from "jquery";
import "jquery-serializejson";
import svg4everybody from "svg4everybody";
import "objectFitPolyfill";

import Page from "webPage/Page";
import Track from "util/Track";
import {handleStickyNav} from "util/handleStickyNav";
import cookieBanner from "util/cookieBanner";
import handleEcologiData from "util/handleEcologiData";
import CookieHelper from "base/CookieHelper";
import handleInstagramFeed from "util/handleInstagramFeed";

window.$ = jQuery;

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $('html').addClass('ie11');
    }

    $('body').on('click', 'a[href^="mailto:"]', function (e) {
        return gtag_report_mail_conversion($(this).attr('href'));
    }).on('click', 'a[href^="/get-a-quote/"], a[href^="/get-a-quote/bespoke-product"]', function (e) {
        let href = $(this).attr('href');

        if (['/get-a-quote/', '/get-a-quote/bespoke-product'].indexOf(window.location.pathname) === -1) {
            CookieHelper.set('quote-button-clicked', window.location.pathname, 1);
        }

        if (href === '/get-a-quote/') {
            return gtag_report_global_quote(href);
        }

        return gtag_report_bespoke_quote(href);
    }).on('click', 'a[href^="tel:"]', function () {
        gtag_report_tel_conversion($(this).attr('href'));
    }).on('click', '.js-menu-btn', function () {
        $('body').toggleClass('nav-active');
        return false;
    }).on('click', '.js-close-navigation', function () {
        $('body').toggleClass('nav-active');
        return false;
    }).on('click', '.js-dropdown-toggle', function () {
        $(this).toggleClass('navigation__toggle--active').next('.dropdown').toggleClass('dropdown--active').slideToggle();
        return false;
    }).on('click', '.js-open-search', function () {
        $('body').addClass('search-active');
        $('.js-search-form').find('.field__input').focus();
        return false;
    }).on('click', '.js-close-search', function () {
        $('body').removeClass('search-active');
        return false;
    });

    $(document).on('gform_confirmation_loaded', function (event, formId) {
        try {
            if (formId === 4 /* Contact Form */) {
                dataLayer.push({'event': 'submit-contact'});
            } else if (formId === 5 /* Newsletter */) {
                dataLayer.push({'event': 'submit-newsletter'});
            } else if (formId === 2 /* Product Quote Form */) {
                dataLayer.push({'event': 'submit-product-quote'});
            } else if (formId === 3 /* Bespoke Quote Form */) {
                dataLayer.push({'event': 'submit-get-quote'});
            }
        } catch (e) {
            console.log(e);
        }
    });

    svg4everybody();
    Page.init();
    handleStickyNav();
    handleEcologiData();
    handleInstagramFeed();

    outputImageSizes();

    if ($('.js-hero-image').length > 0) {
        setInterval(() => {
            rotateHeroImages();
        }, 3000);
    }

    let $imageTrack = $(".js-image-track-wrap");

    if ($imageTrack.length > 0) {
        new Track($imageTrack, {
            classes: {
                block: "slider",
            },
        });
    }
});

function gtag_report_global_quote(url) {
    try {
        dataLayer.push({
            'event': 'global-quote-click', 'eventCallback': function () {
                window.location.href = url;
            }
        });
    } catch (e) {
    }
    return false;
}

function gtag_report_bespoke_quote(url) {
    try {
        dataLayer.push({
            'event': 'bespoke-quote-click', 'eventCallback': function () {
                window.location.href = url;
            }
        });
    } catch (e) {
    }
    return false;
}

function gtag_report_mail_conversion(url) {
    try {
        dataLayer.push({
            'event': 'email-click', 'eventCallback': function () {
                window.location.href = url;
            }
        });
    } catch (e) {
    }
    return false;
}

function gtag_report_tel_conversion(url) {
    try {
        dataLayer.push({'event': 'phone-click'});
    } catch (e) {
    }
}

export function svg_include(icon, suffix = '') {
    return '<svg><use xlink:href="/wp-content/themes/efx/includes/svg-icons.svg?#' + icon + '"></use></svg>';
}

export function outputImageSizes() {
    let $imageWrap = $('.js-output-image-sizes');

    if ($imageWrap.length > 0) {
        $imageWrap.find('.bg-image').each(function (index) {
            console.log('Item: ' + index + ' width: ' + $(this).outerWidth() + ' height: ' + $(this).outerHeight());
        });
    }
}

export function rotateHeroImages() {
    let $all_containers = $('.js-hero-image:not(.hero-images__image--just-changed)');
    let $chosen_container = $all_containers.eq(Math.round(Math.random() * ($all_containers.length - 1)));

    let $candidate_images = $chosen_container.find('.hero-images__image-inner:not(.hero-images__image-inner--active)');

    if ($candidate_images.length === 0) return;

    let $chosen_image = $candidate_images.eq(Math.round(Math.random() * ($candidate_images.length - 1)));


    $chosen_container.find('.hero-images__image-inner--active').removeClass('hero-images__image-inner--active');
    setTimeout(function () {
        $chosen_image.addClass('hero-images__image-inner--active');
    }, 800);

    $('.hero-images__image--just-changed').removeClass('hero-images__image--just-changed');
    $chosen_container.addClass('hero-images__image--just-changed');
}

window.$ = window.jQuery = $;
window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
